import { render, staticRenderFns } from "./Bigstory.vue?vue&type=template&id=7b4d57d8"
import script from "./Bigstory.vue?vue&type=script&lang=js"
export * from "./Bigstory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports